import { render, staticRenderFns } from "./SupportMenu.vue?vue&type=template&id=78987545&scoped=true&"
import script from "./SupportMenu.vue?vue&type=script&lang=js&"
export * from "./SupportMenu.vue?vue&type=script&lang=js&"
import style0 from "./SupportMenu.vue?vue&type=style&index=0&id=78987545&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78987545",
  null
  
)

export default component.exports